<template>
  <div class="sa-answer">
    <ul class="sa-answer-title frc">
      <li class="sa-answer-name">{{assesmentName}}</li>
      <li>考核时长: {{assessmentDuration}}分钟</li>
      <li style="width: 180px">剩余时间: {{endTimeMinute}}分{{endTimeSecond}}秒</li>
      <li class="submit-assessment" @click="showDialogVisible">提交考核</li>
    </ul>
    <div class="sa-answer-content">
      <div class="sa-answer-left">
        <template v-for="(assessmentAnswerItem, assessmentAnswerIndex) of assessmentAnswer">
          <ul v-bind:key="assessmentAnswerIndex">
            <li class="title">{{assessmentAnswerItem.name}}</li>
            <ul class="number-list" v-if="assessmentAnswerItem.assessmentList">
              <template v-for="(_assessmentItem, _assessmentIndex) in assessmentAnswerItem.assessmentList">
                <li v-bind:key="_assessmentIndex" :class="_assessmentItem.topicId == _assessmentItem.topicId || _assessmentItem.correctAnswer || _assessmentItem.multipleList.length > 0 ? 'number-selected':'number-normal'" v-on:click="assessmentIndexTap(assessmentAnswerIndex, _assessmentIndex)">
                  {{_assessmentIndex + 1}}
                </li>
              </template>
            </ul>
          </ul>
        </template>
      </div>
      <div class="sa-answer-right">
        <p class="title">{{assessmentItem.questionName}}</p>
          <ul class="options" v-show="topicTypeId == 1">
            <li class="option">
              <el-radio v-model="assessmentItem.correctAnswer" label="A">{{assessmentItem.aOption}}</el-radio>
            </li>
            <li class="option">
              <el-radio v-model="assessmentItem.correctAnswer" label="B">{{assessmentItem.bOption}}</el-radio>
            </li>
            <li class="option">
              <el-radio v-model="assessmentItem.correctAnswer" label="C">{{assessmentItem.cOption}}</el-radio>
            </li>
            <li class="option">
              <el-radio v-model="assessmentItem.correctAnswer" label="D">{{assessmentItem.dOption}}</el-radio>
            </li>
          </ul>
          <div class="options" v-show="topicTypeId == 2">
            <el-checkbox-group v-model="assessmentItem.multipleList">
              <p class="option" v-if="assessmentItem.aOption != null && assessmentItem.aOption != ''">
                <el-checkbox label="A">{{assessmentItem.aOption}}</el-checkbox>
              </p>
              <p class="option" v-if="assessmentItem.bOption != null && assessmentItem.bOption != ''">
                <el-checkbox label="B">{{assessmentItem.bOption}}</el-checkbox>
              </p>
              <p class="option" v-if="assessmentItem.cOption != null && assessmentItem.cOption != ''">
                <el-checkbox label="C">{{assessmentItem.cOption}}</el-checkbox>
              </p>
              <p class="option" v-if="assessmentItem.dOption != null && assessmentItem.dOption != ''">
                <el-checkbox label="D">{{assessmentItem.dOption}}</el-checkbox>
              </p>
              <p class="option" v-if="assessmentItem.eOption != null && assessmentItem.eOption != ''">
                <el-checkbox label="E">{{assessmentItem.eOption}}</el-checkbox>
              </p>
              <p class="option" v-if="assessmentItem.fOption != null && assessmentItem.fOption != ''">
                <el-checkbox label="F">{{assessmentItem.fOption}}</el-checkbox>
              </p>
            </el-checkbox-group>
          </div>
          <ul class="options" v-show="topicTypeId == 3">
            <li class="option">
              <el-radio v-model="assessmentItem.correctAnswer" label="T">对</el-radio>
              <el-radio v-model="assessmentItem.correctAnswer" label="F">错</el-radio>
            </li>
          </ul>
          <div class="options" v-show="topicTypeId == 4">
            <div style="margin: 0px 0px 10px 0px">答案:</div>
            <el-input type="textarea" v-model="assessmentItem.correctAnswer"></el-input>
          </div>
      </div>
    </div>
  </div>
</template>

<script>
let assesmentTimeInterval = null;

export default {
  name: "StudentAssessmentAnswer",
  components: {},
  data () {
    return {
      assesmentId: 0,
      assesmentName: "",
      assessmentAnswer: [
        {
          name: "一、单选题",
          topicTypeId: 1,
          assessmentList: []
        },
        {
          name: "二、多选题",
          topicTypeId: 2,
          assessmentList: []
        },
        {
          name: "三、判断题",
          topicTypeId: 3,
          assessmentList: []
        },
        {
          name: "四、问答题",
          topicTypeId: 4,
          assessmentList: []
        }
      ],
      assessmentAnswerIndex: 0,
      topicTypeId: 1,
      assessmentItem: {
        topicId: 0,
        questionName: "",
        aOption: "",
        bOption: "",
        cOption: "",
        dOption: "",
        eOption: "",
        fOption: "",
        correctAnswer: "",
        multipleList: []
      },
      requestParams: {},
      assessmentDuration: 0,
      endTimeMinute: 0,
      endTimeSecond: 0,
      singleArr:[], // 单选题
      multipleArr:[], // 多选题
      judgeArr:[], // 判断题
      qaArr:[], // 问答题
    };
  },
  mounted () {
    this.getLearnAssesmentFun(this);
  },
  methods: {
    getLearnAssesmentFun (that) {
      let _assesmentId = this.$route.query.assesmentId;
      that.HttpConnection.get("/learn/assesment/getLearnAssesment/" + _assesmentId).then(function (response) {
        that.assesmentName = response.data.assesmentName;
        that.assesmentId = response.data.assesmentId;
        let singleArr = [];
        let multipleArr = [];
        let judgeArr = [];
        let qaArr = [];
        for (let _item of response.data.learnTopics) {
          let _topicItem = {
            topicId: _item.topicId,
            questionName: _item.topicContent,
            aOption: _item.aOption,
            bOption: _item.bOption,
            cOption: _item.cOption,
            dOption: _item.dOption,
            eOption: _item.eOption,
            fOption: _item.fOption,
            correctAnswer: "",
            multipleList: []
          };
          if (_item.topicTypeId === '1') {
            singleArr.push(_topicItem);
          } else if (_item.topicTypeId === '2') {
            multipleArr.push(_topicItem);
          } else if (_item.topicTypeId === '3') {
            judgeArr.push(_topicItem);
          } else if (_item.topicTypeId === '4') {
            qaArr.push(_topicItem);
          }
        }

        that.assessmentAnswer[0].assessmentList = singleArr;
        that.assessmentAnswer[1].assessmentList = multipleArr;
        that.assessmentAnswer[2].assessmentList = judgeArr;
        that.assessmentAnswer[3].assessmentList = qaArr;
        if(singleArr.length > 0){
          that.assessmentIndexTap(0, 0);
        }else if(multipleArr.length > 0){
          that.assessmentIndexTap(1, 0);
        }else if(judgeArr.length > 0){
          that.assessmentIndexTap(2, 0);
        }else if(qaArr.length > 0){
          that.assessmentIndexTap(3, 0);
        }
        

        let startTime = new Date(response.data.assesmentStartTime).getTime();
        let endTime = new Date(response.data.assesmentEndTime).getTime();
        that.assessmentDuration = parseInt((endTime - startTime) / (60 * 1000));

        assesmentTimeInterval = setInterval(function () {
          let currentTime = new Date().getTime();
          that.endTimeMinute = parseInt((endTime - currentTime) / (60 * 1000));
          that.endTimeSecond = parseInt((endTime - currentTime) / 1000 % 60);
        }, 1000);
      });
    },
    showDialogVisible () {
      let that = this;
      let learnAnswerDataList = [];
      for (let itemA of that.assessmentAnswer) {
        for (let itemB of itemA.assessmentList) {
          if (itemA.topicTypeId === 2) {
            learnAnswerDataList.push({
              "topicId": itemB.topicId,
              "solution": itemB.multipleList.join("")
            });
          } else {
            learnAnswerDataList.push({
              "topicId": itemB.topicId,
              "solution": itemB.correctAnswer
            });
          }
        }
      }
      let requestParams = {
        assesmentId: that.assesmentId,
        learnAnswerDataList: learnAnswerDataList
      };
      that.HttpConnection.post("/learn/assesment/assesdata", requestParams).then(function (response) {
        clearInterval(assesmentTimeInterval);
        that.$message.success("提交成功!");
        that.$router.go(-1);
      });
    },
    assessmentIndexTap (assessmentAnswerIndex, assessmentIndex) {
      if(this.assessmentAnswer[assessmentAnswerIndex].assessmentList[assessmentIndex]){
        this.assessmentItem = this.assessmentAnswer[assessmentAnswerIndex].assessmentList[assessmentIndex];
      }
      this.topicTypeId = this.assessmentAnswer[assessmentAnswerIndex].topicTypeId;
    }
  },
  destroyed () {
    clearInterval(assesmentTimeInterval);
  }
};
</script>

<style scoped lang="scss">
$bgc: #f5f7fa;
$commonColor: #20a0ff;
.sa-answer {
}
.sa-answer-title {
  justify-content: space-between;
  padding: 20px 0px 20px 0px;
  .sa-answer-name {
    font-size: 20px;
    font-weight: bold;
  }
}
.submit-assessment {
  width: 92px;
  height: 34px;
  text-align: center;
  line-height: 34px;
  background-color: $commonColor;
  color: #ffffff;
  border-radius: 4px;
  cursor: pointer;
}
.sa-answer-content {
  height: 700px;
  display: flex;
  flex-direction: row;
  border: 1px solid #8e8585;
}
.sa-answer-left {
  width: 260px;
  min-width: 260px;
  .title {
    background-color: $commonColor;
    color: #ffffff;
    padding: 10px 10px 10px 10px;
    font-size: 18px;
    font-weight: bold;
  }
  .number-list {
    display: flex;
    flex-direction: row;
    padding: 20px 10px 20px 10px;
    flex-wrap: wrap;
    justify-content: left;
  }
  .number-selected {
    width: 30px;
    height: 30px;
    text-align: center;
    line-height: 30px;
    background-color: $commonColor;
    color: #ffffff;
    margin: 2px 6px;
    cursor: pointer;
  }
  .number-normal {
    width: 30px;
    height: 30px;
    text-align: center;
    line-height: 30px;
    background-color: $bgc;
    color: #000000;
    margin: 2px 6px;
    cursor: pointer;
  }
}
.sa-answer-right {
  flex-grow: 1;
  background-color: #f5f7fa;
  padding: 60px 50px 50px 50px;
  .options {
    margin: 30px 0px 0px 0px;
  }
  .option {
    margin: 8px 0px 8px 4px;
  }
}
.teacher {
  margin: 0px 0px 20px 0px;
}
</style>

